const sortBy = document.querySelector('.gcx-resource-sort__select');
const currentUrl = new URL(window.location.href);

if (sortBy) {
	sortBy.addEventListener('change', (e) => {
		const el = e.currentTarget;
		const value = e.currentTarget.value;
		const segments = value.split(':');
		let order = segments[0];

		// Check if value contains order by and direction.
		if (segments[1]) {
			order = segments[1];
			// Add order by to URL.
			currentUrl.searchParams.set('orderby', segments[0]);
		}

		currentUrl.searchParams.set(el.name, order);
		window.location.href = currentUrl.href;
	});
}
